import styled from 'styled-components';
import theme from '../../const/theme';
import { portImg1 } from '../../img/portfolio';
import { Carousel } from 'react-carousel-minimal';

export const PortafolioCarousel =styled(Carousel)`
    height: 65vh !important;
    max-height: 65vh !important;

`
export const PortfolioContainer = styled.div`
    max-width: 1270px;
    width: 100%;
    //background-color: ${theme.COLORS.GRAY};
    border-radius: 50px;
    margin: 75px auto;
    padding: 3em 0;
    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100;

    }
`

export const PortfoliosTextWrapper = styled.div`
    text-align: center;
`

export const PortfolioWrapper = styled.div`
    width: 100%;
`

export const PortfolioRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 50px 20px;

    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0;
        align-items: center;
    }
`


export const PortfoliosCard = styled.div`
   // background-color: ${({white})=> (white ? "#FFF" : "tranparent")};
   background: url(${({image})=> (image && image)});
   background-size: cover;

    max-width: 48%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 0;
    margin: 0;
    height: 425px;
    border-radius: 50px;
    transition: all 0.2s ease-in-out;
    box-sizing: content-box;
    box-shadow: 0px 0px 20px 1px rgba(0,0,200,0.3);
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,200,0.1);
    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }

    @media screen and (max-width: 768px){
        max-width: 90%;
        width: 100%;
        margin-bottom: 20px;

    }
    
`

export const PortfoliosIcon = styled.img`
    height: 100px;
    width: 100px;
    margin-bottom: 10px;
`

export const PortfoliosH1 = styled.h1`
    font-family: 'Barlow Condensed', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 25px;
    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 30px; 
        text-align: center;
        padding-top: 30px;

    }
`
export const PortfoliosH2 = styled.h2`
    font-size: 1rem;
    font-weight:500;
    margin-bottom: 10px;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#000')};
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: .8rem;
        text-align: center;
    }
`
export const PortfoliosP = styled.p`
    font-size: .8rem;
    text-align: center;
    color: ${({textWhite}) => (textWhite ? '#FFF' : '#777')};
`